import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M24 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2Zm-4.5 13a1 1 0 0 1-1 1h-3.75a.25.25 0 0 0-.25.25v2.25a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-2.25a.25.25 0 0 0-.25-.25H5.5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h1a.25.25 0 0 1 .25.25V9a.75.75 0 0 0 1.5 0V6.25A.25.25 0 0 1 8.5 6h1a.25.25 0 0 1 .25.25V9a.75.75 0 0 0 1.5 0V6.25A.25.25 0 0 1 11.5 6h1a.25.25 0 0 1 .25.25V9a.75.75 0 0 0 1.5 0V6.25A.25.25 0 0 1 14.5 6h1a.25.25 0 0 1 .25.25V9a.75.75 0 0 0 1.5 0V6.25A.25.25 0 0 1 17.5 6h1a1 1 0 0 1 1 1Z"
    }, null, -1)
  ]));
}
const computerDeviceNetworkEthernetCat6 = { render };
export {
  computerDeviceNetworkEthernetCat6 as default,
  render
};
//# sourceMappingURL=computer-device-network-ethernet-cat6.svg.js.map
